export default "__VITE_ASSET__CowSC$cU__"